import { Badge, styled } from "@mui/material";



const StyledBadge = styled(Badge)(({ bgColor }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: bgColor || "gray",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "8px",
    fontSize: "0.75rem",
    display: 'flex',
    alignItems: 'center'
  },
}));

const StatusBadge = ({ status, color }) => {
  return <StyledBadge badgeContent={status} bgColor={color} />;
};

export default StatusBadge;
